import { render, staticRenderFns } from "./DisplayContent.vue?vue&type=template&id=d2d435a8&scoped=true"
import script from "./DisplayContent.vue?vue&type=script&lang=js"
export * from "./DisplayContent.vue?vue&type=script&lang=js"
import style0 from "./DisplayContent.vue?vue&type=style&index=0&id=d2d435a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d435a8",
  null
  
)

export default component.exports